import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getOktaForgotPasswordUrl, getOktaSession, logOutOfOkta } from '../../utils';
import { LoginForm } from './LoginForm';
export const OktaLoginForm = ({ oktaUrl, onLogin, onRegister, footerElement, footerHtml }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [session, setSession] = React.useState();
    React.useEffect(() => {
        setLoading(true);
        setSession(undefined);
        getOktaSession(oktaUrl)
            .then((response) => {
            setLoading(false);
            setSession(response);
        })
            .catch(() => {
            setLoading(false);
            setSession(undefined);
        });
    }, [oktaUrl]);
    const handleLoginContinue = () => {
        onLogin(navigate, session === null || session === void 0 ? void 0 : session.login);
    };
    const [disabled, setDisabled] = React.useState(false);
    const handleLoginOther = () => {
        setDisabled(true);
        logOutOfOkta(oktaUrl).finally(() => {
            setDisabled(false);
            onLogin(navigate);
        });
    };
    if (loading) {
        return (React.createElement(Box, null,
            React.createElement(CircularProgress, null)));
    }
    else {
        return (React.createElement(LoginForm, { disabled: disabled, loginEmail: session === null || session === void 0 ? void 0 : session.login, onLoginContinue: handleLoginContinue, onLoginOther: handleLoginOther, onLogin: onLogin, forgotPasswordHref: getOktaForgotPasswordUrl(oktaUrl), onRegister: onRegister, footerElement: footerElement, footerHtml: footerHtml }));
    }
};
